type Theme = 'light' | 'dark' | 'system'

export function useTheme() {
    const theme = useState<Theme>('theme', () => 'system')

    function apply(value: Theme): void {
        if (!import.meta.client) {
            return
        }

        const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
        const isDark = value === 'dark' || (value === 'system' && prefersDark)

        document.documentElement.classList.toggle('dark', isDark)
    }

    function set(value: Theme): void {
        theme.value = value

        if (import.meta.client) {
            localStorage.setItem('groceries-theme', value)
        }

        apply(value)
    }

    function init(): void {
        if (!import.meta.client) {
            return
        }

        const stored = (localStorage.getItem('groceries-theme') as Theme | null) ?? 'system'
        theme.value = stored
        apply(stored)

        window
            .matchMedia('(prefers-color-scheme: dark)')
            .addEventListener('change', () => apply(theme.value))
    }

    return { theme, set, init }
}
